import styled from "styled-components";

import { ContentSectionContainerStyled } from "@Console/components/molecules/ContentSection/molecules/atoms/Container/styles";
import { ContentSectionRowContainer } from "@Console/components/molecules/ContentSection/molecules/atoms/Row/styles";

export const ConsoleGroupModerationPageContainer = styled.div`
  max-width: 900px;
  margin: 5rem auto;

  padding: 0 1rem;
  width: 100%;

  @media (max-width: 850px) {
    margin-top: 2rem;
  }

  hr {
    margin: 3rem 0;

    border-color: ${({ theme }) =>
      theme.mode === "dark"
        ? theme.console.sidebar.borderColor
        : "#5757571a"} !important;
  }

  ${ContentSectionRowContainer} {
    .row-texts {
      .title {
        margin-bottom: 4px;
      }
    }
  }

  ${ContentSectionContainerStyled} .content-section-title {
    border-bottom: 1px solid ${({ theme }) => theme.console.sidebar.borderColor};
    padding-bottom: 8px;
  }
`;
